import { FC, useEffect, useState } from "react"
import { TextStyle } from "react-native"

import { Text } from "@/components/Text"

interface AnimatedSyncingTextProps {
  style?: TextStyle
  animationDuration?: number
}

export const AnimatedSyncingText: FC<AnimatedSyncingTextProps> = ({
  style,
  animationDuration = 600,
}) => {
  const [currentDot, setCurrentDot] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDot((prev) => (prev + 1) % 4)
    }, animationDuration / 2)

    return () => clearInterval(interval)
  }, [animationDuration])

  const dotPatterns = [".", "..", "...", ""]
  const currentPattern = dotPatterns[currentDot]

  const fullText = `Termin bestätigt - wir verbinden dich mit deiner Prüfstelle${currentPattern}`

  return <Text style={style} text={fullText} preset="heading" />
}

// Keep the old AnimatedDots for backward compatibility but make it simple
interface AnimatedDotsProps {
  style?: TextStyle
  animationDuration?: number
}

export const AnimatedDots: FC<AnimatedDotsProps> = ({ style, animationDuration = 600 }) => {
  const [currentDot, setCurrentDot] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDot((prev) => (prev + 1) % 4)
    }, animationDuration / 2)

    return () => clearInterval(interval)
  }, [animationDuration])

  const dotPatterns = ["", ".", "..", "..."]
  const currentPattern = dotPatterns[currentDot]

  return <Text style={style} text={currentPattern} />
}
